module.exports = __webpack_public_path__ + "img/portfolio_icon.eb35fd89.png";